<template>
  <v-card class="mx-4 my-6" :style="cardClass" id="device-status">
    <v-card-title>Device Status</v-card-title>
    <div
      class="pb-2 mx-2 d-flex justify-space-around"
      v-if="details.rental_status"
    >
      <v-btn :color="buttonColor(status, [2])" id="device-overdue-radio"
        ><v-radio-group v-model="status"
          ><v-radio :value="2" color="#FFFFFF"/></v-radio-group
        >Overdue</v-btn
      >
      <v-btn :color="buttonColor(status, [3, 4, 1])" id="device-reported-radio"
        ><v-radio-group v-model="status"
          ><v-radio :value="1" color="#FFFFFF"/></v-radio-group
        >Reported</v-btn
      >
    </div>
  </v-card>
</template>

<script>
import { mapActions } from 'vuex';
import ReconciliationDetailData from '@/mixins/ReconciliationDetailData';
import { MobileView } from '@/mixins';
import card from '@/mixins/card';

export default {
  data: () => ({
    status: 2,
  }),
  mixins: [ReconciliationDetailData, MobileView, card],
  methods: {
    ...mapActions({
      _uploadDetails: 'reconciliationDetails/updateStatus',
      createStatus: 'reconciliationDetails/createStatus',
    }),
    buttonColor(status, name) {
      if (name.includes(status)) {
        return '#3787B7';
      }
      return '#FFFFFF';
    },
  },
  computed: {
    cardClass() {
      if (this.showMobileView) {
        return 'overflow:hidden;';
      }
      return 'width:50%; overflow:hidden;';
    },
  },
  watch: {
    status() {
      const statusObj = {
        id: this.details.rental_status,
        rentalStatusScreenId: this.details.screen_id,
        status: Number(this.status),
      };
      this._uploadDetails(statusObj);
    },
    data: {
      handler() {
        if (!this.details.rental_status) {
          const statusObj = {
            rentalStatusScreenId: this.details.screen.id,
            status: 2,
          };
          this.createStatus(statusObj);
        } else if (
          this.details.rental_status === 'Checked In'
            || this.details.rental_status === 'Checked Out'
        ) {
          this.status = 1;
        } else {
          this.status = 2;
        }
      },
      deep: true,
    },
  },
};
</script>

<style></style>
